import {
  ContentfulSizeChart,
  ContentfulSizeChartSection,
} from '@src/quince-site-common/src/domains/contentful/ContentfulProduct'

const getSortedSizeChartSections = (
  sections: ContentfulSizeChartSection[] | undefined,
): ContentfulSizeChartSection[] => {
  if (!sections?.length) return []

  const defaultIndex = sections.findIndex(section => section?.isDefault === true)
  if (defaultIndex <= 0) return sections

  const defaultSection = sections[defaultIndex]
  if (!defaultSection) return sections

  return [defaultSection, ...sections.slice(0, defaultIndex), ...sections.slice(defaultIndex + 1)]
}

export const normalizeSizeChartDefaultUnitOrder = (
  sizeChart: ContentfulSizeChart | undefined | null,
  enabled = false,
): ContentfulSizeChart | undefined => {
  if (!sizeChart) return undefined
  if (!enabled) return sizeChart

  return {
    ...sizeChart,
    sections: getSortedSizeChartSections(sizeChart.sections),
  }
}
